<template>
  <div
    class="modal fade"
    id="workTaskModal"
    tabindex="-1"
    aria-labelledby="workTaskModalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content" v-if="task">
        <div class="modal-header">
          <h5 class="modal-title" id="workTaskModalLabel">
            {{ task.name }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row g-3 whitebg-input custom-input">
            <div class="col-12">
              <label class="form-label">Task Name</label>
              <input
                type="text"
                class="form-control"
                v-model="task.name"
                @change="updateTask('name')"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Status</label>
              <v-select
                v-model="task.status"
                :options="statusOptions"
                :reduce="(opt) => opt.id"
                label="name"
                @update:modelValue="updateTask('status')"
              >
                <template #option="option">
                  <i :class="'bi bi-' + option.icon + ' me-2'"></i>
                  {{ option.name }}
                </template>
              </v-select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Priority</label>
              <v-select
                v-model="task.priority"
                :options="priorityOptions"
                :reduce="(opt) => opt.id"
                label="name"
                @update:modelValue="updateTask('priority')"
              >
                <template #option="option">
                  <i :class="'bi bi-' + option.icon + ' me-2'"></i>
                  {{ option.name }}
                </template>
              </v-select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Assigned User</label>
              <v-select
                v-model="task.user_id"
                :options="users"
                :reduce="(opt) => opt.id"
                label="full_name"
                @update:modelValue="updateTask('user_id')"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Estimated Duration</label>
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  v-model="task.estimated_duration"
                  @change="updateTask('estimated_duration')"
                />
                <span>min</span>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Planned start at</label>
              <input
                type="date"
                class="form-control"
                v-model="task.started_at"
                @change="updateTask('started_at')"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Planned length</label>
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  v-model="task.day_durations"
                  @change="updateTask('day_durations')"
                />
                <span>days</span>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label">Description</label>
              <textarea
                class="form-control"
                rows="4"
                v-model="task.description"
                @change="updateTask('description')"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import WorkTaskStatuses from "@/modules/WorkTaskStatuses";
import WorkTaskPriorities from "@/modules/WorkTaskPriorities";
import http from "@/modules/http";

export default {
  name: "WorkTaskModal",
  props: {
    users: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modal: null,
      task: null,
      statusOptions: Object.values(WorkTaskStatuses),
      priorityOptions: Object.values(WorkTaskPriorities),
    };
  },
  mounted() {
    this.modal = new Modal(this.$refs.modal);
  },
  methods: {
    show(task) {
      this.task = { ...task };
      this.modal.show();
    },
    updateTask(field) {
      const data = {};
      data[field] = this.task[field];
      http
        .fetch(`/work/tasks/${this.task.id}`, data, true, "PUT")
        .then((res) => {
          if (res.success) {
            this.$emit("updated", res.task);
          }
        });
    },
  },
};
</script>
